class StickyProductForm {
  constructor() {
    this.footer = document.querySelector("[data-sticky-footer]");
    if (!this.footer) {
      //   console.log("No sticky footer found");
      return;
    }

    this.mainForm = document.querySelector("[data-product-form]");
    this.mainAddToCartBtn = document.querySelector(".product__submit__add");
    if (!this.mainAddToCartBtn) {
      //   console.log("No main add to cart button found");
      return;
    }

    this.stickyForm = this.footer.querySelector("[data-product-form]");
    if (!this.stickyForm) {
      //   console.log("No sticky form found");
      return;
    }

    // console.log("StickyProductForm initialized");
    this.init();

    this.stickySelectors = this.footer.querySelectorAll(
      "[data-sticky-option-selector]"
    );
    this.mainSelectors = this.mainForm.querySelectorAll("select[data-index]");
    this.stickyVariantInput = this.stickyForm.querySelector('[name="id"]');
    this.mainVariantInput = this.mainForm.querySelector('[name="id"]');
  }

  init() {
    this.handleScroll = this.handleScroll.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);

    // Initial check
    this.handleScroll();

    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);

    // Sync variant selectors
    const stickySelects = this.footer.querySelectorAll("[data-sticky-select]");
    stickySelects.forEach((select) => {
      select.addEventListener("click", (e) => {
        const option = e.target.closest("[data-popout-option]");
        if (!option) return;

        const value = option.getAttribute("data-value");
        const index = option.getAttribute("data-index");

        // Update main form selector
        const mainSelector = this.mainForm.querySelector(
          `[data-index="${index}"]`
        );
        if (mainSelector) {
          mainSelector.value = value;
          mainSelector.dispatchEvent(new Event("change"));
        }
      });
    });

    // Listen for variant changes on main form
    this.mainForm.addEventListener("variantChange", this.handleVariantChange);

    // this.stickySelectors.forEach((selector) => {
    //   selector.addEventListener("change", (e) => {
    //     const index = e.target.getAttribute("data-index");
    //     const value = e.target.value;

    //     // Find and update main form selector
    //     const mainSelector = this.mainForm.querySelector(
    //       `select[data-index="${index}"]`
    //     );
    //     if (mainSelector) {
    //       mainSelector.value = value;
    //       mainSelector.dispatchEvent(new Event("change", { bubbles: true }));
    //     }

    //     // Update sticky variant ID after main form updates
    //     setTimeout(() => {
    //       if (this.mainVariantInput && this.stickyVariantInput) {
    //         this.stickyVariantInput.value = this.mainVariantInput.value;
    //       }
    //     }, 100);
    //   });
    // });

    // Add main form selector sync
    // this.mainSelectors.forEach((selector) => {
    //   selector.addEventListener("change", (e) => {
    //     const index = e.target.getAttribute("data-index");
    //     const value = e.target.value;

    //     // Find and update sticky form selector
    //     const stickySelector = this.footer.querySelector(
    //       `select[data-index="${index}"]`
    //     );
    //     if (stickySelector) {
    //       stickySelector.value = value;
    //     }

    //     // Update sticky variant ID
    //     if (this.mainVariantInput && this.stickyVariantInput) {
    //       this.stickyVariantInput.value = this.mainVariantInput.value;
    //     }
    //   });
    // });
  }

  handleScroll() {
    const mainButtonRect = this.mainAddToCartBtn.getBoundingClientRect();
    const isMainButtonVisible =
      mainButtonRect.bottom > 0 && mainButtonRect.top < window.innerHeight;

    // console.log("Main button visible:", isMainButtonVisible);
    // console.log("Button position:", mainButtonRect);

    if (isMainButtonVisible) {
      this.footer.classList.remove("is-visible");
    } else {
      this.footer.classList.add("is-visible");
    }
  }

  handleVariantChange(event) {
    const variant = event.detail.variant;

    // Update sticky form variant ID
    const stickyVariantInput = this.stickyForm.querySelector(
      "[data-sticky-variant-id]"
    );
    if (stickyVariantInput) {
      stickyVariantInput.value = variant.id;
    }

    // Update price
    const stickyPrice = this.footer.querySelector("[data-sticky-price]");
    if (stickyPrice) {
      stickyPrice.innerHTML = this.mainForm.querySelector(
        "[data-product-price]"
      ).innerHTML;
    }

    // Update add to cart button
    const stickyAddToCart = this.footer.querySelector(
      "[data-sticky-add-to-cart]"
    );
    if (stickyAddToCart) {
      stickyAddToCart.disabled = !variant.available;
      const textSpan = stickyAddToCart.querySelector("[data-add-to-cart-text]");
      if (textSpan) {
        textSpan.textContent = variant.available
          ? theme.strings.addToCart
          : theme.strings.soldOut;
      }

      // Update price in button
      const priceSpan = stickyAddToCart.querySelector(
        "[data-add-to-cart-price]"
      );
      if (priceSpan) {
        const mainPriceInButton = this.mainAddToCartBtn.querySelector(
          "[data-add-to-cart-price]"
        );
        if (mainPriceInButton) {
          priceSpan.innerHTML = mainPriceInButton.innerHTML;
        }
      }
    }
  }
}

// Initialize
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector("[data-product-form]")) {
    new StickyProductForm();
  }
});
